module.exports = __webpack_public_path__ + "images/emoji/love_hotel.fdce2d2143b7ee26e95d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/love_hotel.png
// module id = v1qC
// module chunks = 2